var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.5 45.5C82.5 66.2107 65.7107 83 45 83C24.2893 83 7.5 66.2107 7.5 45.5C7.5 24.7893 24.2893 8 45 8",
    stroke: "black",
    strokeWidth: 3.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2995_184896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 22,
    width: 49,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4343 40.1853L26.25 40.1853L26.25 60.6828L74.932 60.6828L74.932 22.25L54.4343 22.25L54.4343 40.1853Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2995_184896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0938 34.6584L44.1396 55.9795L77.4886 17.126",
    stroke: "black",
    strokeWidth: 3.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSign);
export default __webpack_public_path__ + "static/media/check-sign.c7fc0ddaf26f9fe4e6cf2c623f53a740.svg";
export { ForwardRef as ReactComponent };